import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hasActive } from 'redux/Reducers/PopBallon/VertemGiftApi';

const ONE_HOUR = 5 * 60 * 1000;

const useActiveCampaign = () => {
    const dispatch = useDispatch();
    const { isActiveGift } = useSelector(state => state.VertemGift);
    const [isCallingActiveVertemGift, setIsCallingActiveVertemGift] = useState(false);
    const [isCampaignActive, setIsCampaignActive] = useState(null);

    useEffect(() => {
        const checkActiveStatus = async () => {
            setIsCallingActiveVertemGift(true);
            const storedValue = localStorage.getItem('hasActiveVertemGift');

            if (storedValue) {
                const parsedValue = JSON.parse(storedValue);
                const { value, timestamp } = parsedValue;

                if (Date.now() - timestamp < ONE_HOUR) {
                    setIsCampaignActive(value);
                    setIsCallingActiveVertemGift(false);
                    return;
                }
            }

            try {
                dispatch(hasActive());
                setIsCallingActiveVertemGift(false);
            } catch (error) {
                console.error('Erro ao verificar a campanha ativa:', error);
                setIsCallingActiveVertemGift(false);
            }
        };

        checkActiveStatus();
    }, []);

    useEffect(() => {
        if (isActiveGift !== null) {
            localStorage.setItem('hasActiveVertemGift', JSON.stringify({ value: isActiveGift, timestamp: Date.now() }));

            setIsCampaignActive(isActiveGift);
        }
    }, [isActiveGift]);

    return { isCallingActiveVertemGift, isCampaignActive };
};

export default useActiveCampaign;
